/*
  + determinar como pasarle el rut a la función que se encargará de importar la configuración.
  + tratar de importar la configuración de la empresa
    + intentar importar primero 17882988-2/equisfile.js
  + si no se puede importar o se importo un null,
    + importar la config default.
*/

function setupImportPath(path) {
  return async function tryToImportSpecificConfig(identifier) {
    try {
      const file = await import(`./companies/${identifier}/${path}`);
      return file.default();
    } catch (error) {
      const file = await import(`./default/${path}`);
      return file.default();
    }
  };
}

export default {
  externo: setupImportPath('external'),
  ddExterno: setupImportPath('externalStorage'),
  sharedExternal: setupImportPath('sharedExternal'),
  interno: setupImportPath('internal'),
  custom: setupImportPath('personalizado'),
  personalizado: setupImportPath('personalizado'),
  numInt: setupImportPath('internalNumeration'),
  numOf: setupImportPath('oficialNumeration'),
  flujo: setupImportPath('internalFlow')
};

export const types = {
  ext: 'externo',
  int: 'interno',
  custom: 'personalizado',
  numInt: 'numInt',
  numOf: 'numOf'
};
